import React, {useState} from 'react'
import {Typography, Grid} from '@material-ui/core'
import moment from 'moment'
import '../../styles/Reservation/Reservation.scss'
import './StepSelectDate.scss'
import SelectedItems from './SelectedItems'
import MonthView from './Calendar/MonthView'
import CreateIcon from '@material-ui/icons/Create'
import EditableDateText from './EditableDateText'
import WeekView from './Calendar/WeekView'

const StepSelectDate = ({date_format, time_format}) => {
  const [dateSelection, setDateSelection] = useState('from')
  const [calendarView, setCalendarView] = useState('month') // month || week || day

  const [dateFrom, setDateFrom] = useState(null)
  const [dateTo, setDateTo] = useState(null)

  const handleClickView = (e, view) => {
    setCalendarView(view)
  }

  const handleClickDay = (e, momentDate) => {
    if (dateSelection === 'from' || dateSelection === null) {
      setDateFrom(momentDate)
      return
    }
    if (dateSelection === 'to') {
      setDateTo(momentDate)
    }
  }
  const handleClickTime = (e, momentDate) => {
    if (dateSelection === 'from' || dateSelection === null) {
      setDateFrom(momentDate)
      setDateSelection('to')
      return
    }
    if (dateSelection === 'to') {
      setDateTo(momentDate)
      setDateSelection(null)
    }
  }

  const handleClickSelectDate = (e, selection) => {
    if (dateSelection === selection) {
      setDateSelection(null)
    } else {
      setDateSelection(selection)
    }
  }

  return (
    <>
      <section>
        <Typography className="ap-typography ap-typography--lg">Select date/time</Typography>
        <div className="c-step-select-date">
          <div
            className={`c-step-select-date__wrapper ${
              dateSelection === 'from' ? ' c-step-select-date__wrapper--selected' : null
            }`}
            onClick={e => handleClickSelectDate(e, 'from')}
          >
            <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
              From
            </Typography>
            <div
              className="c-step-select-date__control"
              onClick={e => (dateSelection === 'from' ? e.stopPropagation() : null)}
            >
              <EditableDateText
                onChange={(e, v) => setDateFrom(v)}
                value={dateFrom}
                date_format={date_format}
                time_format={time_format}
              />
            </div>
          </div>
          <div
            className={`c-step-select-date__wrapper ${
              dateSelection === 'to' ? ' c-step-select-date__wrapper--selected' : null
            }`}
            onClick={e => handleClickSelectDate(e, 'to')}
          >
            <Typography className="ap-typography ap-typography--xs" style={{marginBottom: 4}}>
              To
            </Typography>
            <div
              className="c-step-select-date__control"
              onClick={e => (dateSelection === 'to' ? e.stopPropagation() : null)}
            >
              <EditableDateText
                onChange={(e, v) => setDateTo(v)}
                value={dateTo}
                date_format={date_format}
                time_format={time_format}
              />
            </div>
          </div>
        </div>
      </section>
      <section style={{marginTop: 22}}>
        <Grid container style={{marginTop: 0}} spacing={2}>
          <Grid item xs={1}>
            <div className="c-step-select-date-view">
              <div
                className={`c-step-select-date-view__item ap-typography ap-typography--sm ${
                  calendarView === 'month' ? 'c-step-select-date-view__item--selected' : ''
                }`}
                onClick={e => handleClickView(e, 'month')}
              >
                Month
              </div>
              <div
                className={`c-step-select-date-view__item ap-typography ap-typography--sm ${
                  calendarView === 'week' ? 'c-step-select-date-view__item--selected' : ''
                }`}
                onClick={e => handleClickView(e, 'week')}
              >
                Week
              </div>
              <div
                className={`c-step-select-date-view__item ap-typography ap-typography--sm ${
                  calendarView === 'day' ? 'c-step-select-date-view__item--selected' : ''
                }`}
                onClick={e => handleClickView(e, 'day')}
              >
                Day
              </div>
            </div>
          </Grid>
          <Grid item xs={10} style={{flex: 1}}>
            {calendarView === 'month' && (
              <MonthView
                selectedFromMomentDate={dateFrom}
                selectedToMomentDate={dateTo}
                onClickDay={handleClickDay}
                onClickTime={handleClickTime}
                disableDatesBefore={dateSelection === 'to' ? dateFrom : moment()}
                disableDatesAfter={dateSelection === 'from' ? dateTo : null}
              />
            )}
            {calendarView === 'week' && <WeekView />}
          </Grid>
          <Grid item style={{width: 192}}>
            <SelectedItems />
          </Grid>
        </Grid>
      </section>
    </>
  )
}

export default StepSelectDate
